/**
 * Divider roles
 * @public
 */
export var DividerRole;
(function (DividerRole) {
    /**
     * The divider semantically separates content
     */
    DividerRole["separator"] = "separator";
    /**
     * The divider has no semantic value and is for visual presentation only.
     */
    DividerRole["presentation"] = "presentation";
})(DividerRole || (DividerRole = {}));
